/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Nda_Sign_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "Confirming records “{name}” as your electronic signature on this agreement with Black Chantry Productions." |
*
* @param {Nda_Sign_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_sign_confirm_body = /** @type {((inputs: Nda_Sign_Confirm_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Sign_Confirm_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`En confirmant, « ${i?.name} » est enregistré comme votre signature électronique de cet accord avec Black Chantry Productions.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Al confirmar, «${i?.name}» queda registrado como su firma electrónica de este acuerdo con Black Chantry Productions.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Ao confirmar, “${i?.name}” fica registrado como sua assinatura eletrônica deste acordo com a Black Chantry Productions.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Confermando, “${i?.name}” viene registrato come la tua firma elettronica di questo accordo con Black Chantry Productions.`)
	return /** @type {LocalizedString} */ (`Confirming records “${i?.name}” as your electronic signature on this agreement with Black Chantry Productions.`)
});